export default __webpack_public_path__ + "static/media/fad-backward.ca7ff9d7.svg";